import { MultiSelect } from "et3-ui-library/mui";

import i18n from "../../../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import getKhattabatMatchingStore from "../../../../../stores/khattabat-stores/matching-stores";
import {
  TEt3PickerMultipleValue,
  TEt3PickerOption
} from "../../../../../TypesNEW";

const FilterMultiSelect = withLiteObserverAndTheme<{
  label: string;
  options: TEt3PickerOption[];
  value: TEt3PickerMultipleValue;
  onChange: (value: TEt3PickerMultipleValue) => void;
}>((props) => {
  const { label, options, value, onChange } = props;
  const {
    openMultiSelectId,
    multiSelectSearchText,
    openMultiSelect,
    closeMultiSelect,
    setMultiSelectSearchText
  } = getKhattabatMatchingStore();

  return (
    <MultiSelect
      label={label}
      options={options.filter((option) => option.value !== "")}
      value={value}
      onChange={onChange}
      open={openMultiSelectId.get() === label}
      onOpen={() => openMultiSelect(label)}
      onClose={closeMultiSelect}
      searchText={multiSelectSearchText.get()}
      onSearchTextChange={setMultiSelectSearchText}
      placeholder={i18n.get("KHATTABAT_MATCHING_ANY")}
      searchPlaceholder={i18n.get("SEARCH")}
      clearLabel={i18n.get("KHATTABAT_MATCHING_CLEAR_SELECTION")}
    />
  );
});

export default FilterMultiSelect;
